import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

export default class Header extends Component {
	render() {
		return (
			<header class={style.header}>
				<h1>Laurora</h1>
				<nav>
					<Link activeClassName={style.active} href="/">Colours</Link>
					<Link activeClassName={style.active} href="/cards">Cards</Link>
				</nav>
			</header>
		);
	}
}



// WEBPACK FOOTER //
// ./components/header/index.js